<template>
  <span>
    <span :class="['label', `label-production-panel-type-${type}`]">{{formatLookupName(type, ProductionPanelTypeLookup)}}</span>
  </span>
</template>

<script>
import { ProductionPanelTypeLookup } from '@/store/types'

export default {
  name: 'LabelPanelTypeBadge',
  props: {
    type: String,
  },
  created() {
    this.ProductionPanelTypeLookup = ProductionPanelTypeLookup
  },
}
</script>
